import React, { Component } from 'react';
import { ReactTyped } from 'react-typed';
import './styles/App.css';
import './styles/tulevaisuus.scss';
import { Button } from 'reactstrap';
import { Redirect, Route, Switch, Link } from 'react-router-dom';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showBtn: false
    }
  }

  render() {
    return (
      <div className="App">
        <div style={{ zIndex: 1, position: "relative" }}>
          <ReactTyped className="typed"
            strings={["Tervetuloa!", "Kirjaudu sisään Discord-tunnuksellasi aloittaaksesi"]}
            typeSpeed={80}
            backSpeed={50}
            onComplete={() => this.setState({ showBtn: true })}
          />
          <h5 className="my-3">Kirjautumalla sisään hyväksyt palvelun <Link to="/tietosuoja">tietosuojaselosteen</Link></h5>
          {true && <Button color="success" className="mt-3" href="https://discord.com/oauth2/authorize?client_id=693862226678775919&response_type=code&redirect_uri=https%3A%2F%2Fsleakbitjoulu-83e2523361a8.herokuapp.com%2Fauth%2F&scope=identify+email">Kirjaudu</Button>}
        </div>
      </div>
    );
  }
}
export default Login;
